"use client";
import React from "react";
import Badge from "./Badge";
import UsageCard from "./UsageCard";

const UsageBreakdownSection: React.FC = () => {
  const usageData = [
    {
      id: 1,
      title: "Shower",
      amount: "28L",
      percentage: "30%",
      progress: 30,
      imageSrc: undefined,
    },
    {
      id: 2,
      title: "Toilet",
      amount: "26L",
      percentage: "25%",
      progress: 25,
      imageSrc: "https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/d9c2350431937f8eddfddc9a1f67fa64ad869f09?placeholderIfAbsent=true",
    },
    {
      id: 3,
      title: "Taps",
      amount: "18L",
      percentage: "20%",
      progress: 20,
      imageSrc: "https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/cc4213bd4e070418d430078b81f4f68ed32349b7?placeholderIfAbsent=true",
    },
    {
      id: 4,
      title: "Laundry",
      amount: "8L",
      percentage: "15%",
      progress: 15,
      imageSrc: "https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/343d1e62d53da6f82818e98ac5b7c83c3cd33ae4?placeholderIfAbsent=true",
    },
  ];

  return (
    <section className="mt-6 w-full">
      <div className="w-full">
        <div className="pl-3 w-full">
          <header className="w-full text-lg font-semibold leading-loose text-gray-900">
            <div className="flex gap-4 w-full">
              <h2 className="flex-1 shrink w-full basis-0 min-w-60">
                Usage Breakdown
              </h2>
            </div>
          </header>
          <div className="flex gap-4 items-end mt-4 w-full whitespace-nowrap">
            <p className="text-3xl font-semibold leading-none text-gray-900">
              247L
            </p>
            <div className="pb-2 text-sm font-medium leading-none text-center text-emerald-700">
              <Badge variant="success-icon" icon="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/af073f4a61c83535a7896111dbbef16a1b01b1b6?placeholderIfAbsent=true">
                7.2%
              </Badge>
            </div>
          </div>
        </div>

        {usageData.map((item) => (
          <UsageCard
            key={item.id}
            title={item.title}
            amount={item.amount}
            percentage={item.percentage}
            progress={item.progress}
            imageSrc={item.imageSrc}
          />
        ))}
      </div>
    </section>
  );
};

export default UsageBreakdownSection;
